<template>
  <div>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>Livsmiljö</v-list-item-subtitle>
        <v-list-item-title v-for="envId in speciesEnvironments" :key="envId">
          <router-link :to="{ name: getEnvironment(envId).url }">{{
            getEnvironment(envId).name
          }}</router-link>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <!-- <div class="img-livsmiljoer-container">
      <v-img
        class="img-responsive"
        id="img-livsmiljoer"
        src="https://havetstore.blob.core.windows.net/bilder/livet-pwa/livsmiljoer.png"
        alt="Livsmiljöer"
      />
      <div
        id="dot-container"
        :class="positionClass(envId)"
        v-for="envId in speciesEnvironments"
        :key="envId"
      >
        <div class="dot"></div>
        <div class="pulse"></div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'SingleSpeciesEnvironmentMap',
  props: { species: { type: Object, required: true } },
  data() {
    return {
      environments: [
        {
          id: 1,
          name: 'Grunda mjuka bottnar',
          url: 'grunda-mjuka-bottnar'
        },
        {
          id: 2,
          name: 'Grunda klipp- och stenbottnar',
          url: 'grunda-klipp-och-stenbottnar'
        },
        {
          id: 3,
          name: 'Det fria vattnet',
          url: 'det-fria-vattnet'
        },
        {
          id: 4,
          name: 'Djupa mjuka bottnar',
          url: 'djupa-mjuka-bottnar'
        },
        {
          id: 5,
          name: 'Djupa klipp- och stenbottnar',
          url: 'djupa-klipp-och-stenbottnar'
        }
      ]
    }
  },
  computed: {
    speciesEnvironments() {
      const env = this.$store.state.allSpecEnvGroupBySpec
      return env[this.species.id]
    }
  },
  methods: {
    positionClass(envId) {
      if (envId === 1) {
        return 'dot--grunda_mjuk'
      } else if (envId === 2) {
        return 'dot--grunda_klipp'
      } else if (envId === 3) {
        return 'dot--fria_vattnet'
      } else if (envId === 4) {
        return 'dot--djupa_mjuk'
      } else if (envId === 5) {
        return 'dot--grunda_klipp'
      } else return null
    },
    getEnvironment(envId) {
      return this.environments.find(env => env.id === envId)
    }
  }
}
</script>

<style lang="css" scoped>
.img-livsmiljoer-container {
  position: relative;
  padding: 10px;
}

.img-livsmiljoer-container .img-responsive {
  display: block;
  max-width: 100%;
  height: auto;
}
#dot-container {
  position: absolute;
  background: rgba(255, 159, 0, 1);
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}

.dot--grunda_klipp {
  position: relative;
  top: 63%;
  left: 10%;
}
.dot--djupa_klipp {
  position: relative;
  top: 85%;
  left: 33%;
}
.dot--grunda_mjuk {
  position: relative;
  top: 67%;
  left: 83%;
}
.dot--djupa_mjuk {
  position: relative;
  top: 85%;
  left: 63%;
}
.dot--fria_vattnet {
  position: relative;
  top: 60%;
  left: 48%;
}
.dot--offside {
  visibility: hidden;
}
.pulse {
  width: 15px;
  height: 15px;
  border: 5px solid rgba(255, 159, 0, 1);
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 30px;
  background-color: rgba(255, 159, 0, 1);
  z-index: 1;
  position: absolute;
}

.dot {
  border: 10px solid rgba(255, 159, 0, 0.5);
  background: transparent;
  -webkit-border-radius: 60px;
  -moz-border-radius: 60px;
  border-radius: 60px;
  height: 89px;
  width: 89px;
  -webkit-animation: pulse 3s ease-out 0;
  -moz-animation: pulse 3s ease-out 0;
  animation: pulse 3s ease-out 0;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  position: absolute;
  top: -37px;
  left: -37px;
  z-index: 1;
  opacity: 0;
}

@keyframes pulse {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  25% {
    transform: scale(0);
    opacity: 0.1;
  }
  50% {
    transform: scale(0.1);
    opacity: 0.3;
  }
  75% {
    transform: scale(0.5);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
</style>
